import { render } from "./InventoryPage.vue?vue&type=template&id=e3799d06"
import script from "./InventoryPage.vue?vue&type=script&lang=js"
export * from "./InventoryPage.vue?vue&type=script&lang=js"

import "./InventoryPage.vue?vue&type=style&index=0&id=e3799d06&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__